export const en = {
  loadListView: {
    header: {
      expectedShipDate: 'Expected Ship Date',
      supplier: 'Supplier',
      loadNumber: 'Load #',
      purchaseOrderNumber: 'PO #',
      bookingNumber: 'Booking #',
      containerNumber: 'Container #',
      releaseNumber: 'Release #',
      numberOfMaterials: '# of Materials',
      netWeight: 'Net Weight',
      status: 'Status',
      createdAt: 'Created At',
      actions: 'Actions',
    },
  },
  bookingListView: {
    header: {
      bookingNumber: 'Booking #',
      supplier: 'Supplier',
      purchaseOrderNumber: 'Purchase Orders',
      vesselArrivalDate: 'Vessel Arrival Date',
      vesselName: 'Vessel Name',
      status: 'Status',
      internalNotes: 'Internal Notes',
      actions: 'Actions',
    },
  },
  purchaseOrderListView: {
    header: {
      createdOn: 'Created on',
      supplier: 'Supplier',
      poNumber: 'PO#',
      counterpartySoNumber: 'Counterparty SO#',
      numberOfMaterials: '# of Materials',
      netWeight: 'Net Weight',
      shippedLoads: 'Shipped Loads',
      fulfilledPercentage: 'Fulfilled %',
      status: 'Status',
      totalAmount: 'Total',
      actions: 'Actions',
    },
  },
  markLoadAsReceived: {
    loadReceivedOn: 'Load received on',
    loadsReceivedOn: 'Loads received on',
    discard: 'Discard',
    save: 'Save',
    markAsReceived: 'Mark as Received',
  },
  markLoadAsReviewed: {
    loadReceivedOn: 'Load received on',
    receivingTicketNumber: 'Receiving Ticket #',
    receivedTicketIssueDate: 'Received Ticket Issue Date',
    millReceivedWeightPostDate: 'Mill Received Weight Post Date',
    discard: 'Discard',
    markAsReviewed: 'Mark as Reviewed',
  },
  customerBillListView: {
    header: {
      supplierBillNumber: 'Supplier / Bill #',
      total: 'Total',
      payDate: 'Pay Date',
      accountManager: 'Account Manager',
      actions: 'Actions',
    },
  },
};
